import type { Template } from "@/types";

export const PO_07_H5_V2: Template[] = [
{
    id: "po-07-h5v2-01",
    name: "PO 01 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_01.png",
    size: [1136, 854],
    style: {},
        slots: [
            { id: "1", x: 38, y: 157, width: 228, height: 175, rotation: 0, imageRotation: 0 },
            { id: "2", x: 38, y: 340, width: 228, height: 175, rotation: 0, imageRotation: 0 },
            { id: "3", x: 38, y: 523, width: 228, height: 174, rotation: 0, imageRotation: 0 },
            { id: "4", x: 274, y: 157, width: 251, height: 540, rotation: 0, imageRotation: 0 },
            { id: "5", x: 624, y: 240, width: 217, height: 184, rotation: 0, imageRotation: 0 },
            { id: "6", x: 624, y: 432, width: 217, height: 183, rotation: 0, imageRotation: 0 },
            { id: "7", x: 849, y: 240, width: 219, height: 375, rotation: 0, imageRotation: 0 },
        ],
},

{
    id: "po-07-h5v2-02",
    name: "PO 02 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_02.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 64, y: 172, width: 440, height: 330, rotation: 0, imageRotation: 0 },
        { id: "2", x: 64, y: 510, width: 101, height: 172, rotation: 0, imageRotation: 0 },
        { id: "3", x: 173, y: 510, width: 223, height: 172, rotation: 0, imageRotation: 0 },
        { id: "4", x: 404, y: 510, width: 100, height: 172, rotation: 0, imageRotation: 0 },
        { id: "5", x: 632, y: 172, width: 440, height: 337, rotation: 0, imageRotation: 0 },
        { id: "6", x: 632, y: 517, width: 216, height: 165, rotation: 0, imageRotation: 0 },
        { id: "7", x: 856, y: 517, width: 216, height: 165, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-03",
    name: "PO 03 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_03.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 37, y: 172, width: 215, height: 165, rotation: 0, imageRotation: 0 },
        { id: "2", x: 37, y: 345, width: 215, height: 165, rotation: 0, imageRotation: 0 },
        { id: "3", x: 37, y: 518, width: 215, height: 164, rotation: 0, imageRotation: 0 },
        { id: "4", x: 260, y: 172, width: 274, height: 510, rotation: 0, imageRotation: 0 },
        { id: "5", x: 625, y: 172, width: 452, height: 260, rotation: 0, imageRotation: 0 },
        { id: "6", x: 625, y: 440, width: 298, height: 241, rotation: 0, imageRotation: 0 },
        { id: "7", x: 931, y: 440, width: 146, height: 241, rotation: 0, imageRotation: 0 }     
    ],
},

{
    id: "po-07-h5v2-04",
    name: "PO 04 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_04.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 233, width: 483, height: 388, rotation: 0, imageRotation: 0 },
        { id: "2", x: 491, y: 233, width: 124, height: 190, rotation: 0, imageRotation: 0 },      
        { id: "4", x: 491, y: 431, width: 253, height: 190, rotation: 0, imageRotation: 0 },
        { id: "5", x: 752, y: 431, width: 252, height: 190, rotation: 0, imageRotation: 0 },
        { id: "6", x: 623, y: 233, width: 253, height: 190, rotation: 0, imageRotation: 0 },
        { id: "7", x: 884, y: 233, width: 252, height: 190, rotation: 0, imageRotation: 0 },
        { id: "3", x: 1012, y: 431, width: 124, height: 190, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-05",
    name: "PO 05 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_05.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 43, y: 235, width: 296, height: 227, rotation: 0, imageRotation: 0 },
        { id: "2", x: 347, y: 235, width: 295, height: 227, rotation: 0, imageRotation: 0 },
        { id: "3", x: 43, y: 470, width: 195, height: 149, rotation: 0, imageRotation: 0 },
        { id: "4", x: 246, y: 470, width: 194, height: 149, rotation: 0, imageRotation: 0 },
        { id: "5", x: 448, y: 470, width: 194, height: 149, rotation: 0, imageRotation: 0 },
        { id: "6", x: 650, y: 235, width: 218, height: 384, rotation: 0, imageRotation: 0 },
        { id: "7", x: 876, y: 235, width: 217, height: 384, rotation: 0, imageRotation: 0 },    
     
    ],
},

{
    id: "po-07-h5v2-06",
    name: "PO 06 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_06.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 46, y: 127, width: 518, height: 397, rotation: 0, imageRotation: 0 },
        { id: "2", x: 572, y: 127, width: 255, height: 397, rotation: 0, imageRotation: 0 },
        { id: "3", x: 835, y: 127, width: 254, height: 397, rotation: 0, imageRotation: 0 },
        { id: "4", x: 46, y: 532, width: 255, height: 195, rotation: 0, imageRotation: 0 },
        { id: "5", x: 309, y: 532, width: 255, height: 195, rotation: 0, imageRotation: 0 },
        { id: "6", x: 572, y: 532, width: 255, height: 195, rotation: 0, imageRotation: 0 },
        { id: "7", x: 835, y: 532, width: 254, height: 195, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-07",
    name: "PO 07 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_07.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 177, width: 198, height: 162, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 347, width: 198, height: 161, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 516, width: 198, height: 161, rotation: 0, imageRotation: 0 },
        { id: "4", x: 206, y: 177, width: 318, height: 500, rotation: 0, imageRotation: 0 },       
        { id: "5", x: 532, y: 177, width: 318, height: 500, rotation: 0, imageRotation: 0 },
        { id: "6", x: 858, y: 177, width: 278, height: 246, rotation: 0, imageRotation: 0 },
        { id: "7", x: 858, y: 431, width: 278, height: 246, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-08",
    name: "PO 08 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_08.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 0, y: 177, width: 198, height: 162, rotation: 0, imageRotation: 0 },
        { id: "2", x: 0, y: 347, width: 198, height: 161, rotation: 0, imageRotation: 0 },
        { id: "3", x: 0, y: 516, width: 198, height: 161, rotation: 0, imageRotation: 0 },
        { id: "4", x: 206, y: 177, width: 318, height: 500, rotation: 0, imageRotation: 0 },
        { id: "5", x: 532, y: 177, width: 278, height: 246, rotation: 0, imageRotation: 0 },
        { id: "6", x: 532, y: 431, width: 278, height: 246, rotation: 0, imageRotation: 0 },
        { id: "7", x: 818, y: 177, width: 318, height: 500, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-09",
    name: "PO 09 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_09.png",
    size: [1136, 854],
    style: {},
    slots: [     
        { id: "1", x: 46, y: 154, width: 167, height: 131, rotation: 0, imageRotation: 0 },
        { id: "2", x: 46, y: 293, width: 167, height: 131, rotation: 0, imageRotation: 0 },
        { id: "3", x: 46, y: 432, width: 167, height: 131, rotation: 0, imageRotation: 0 },
        { id: "4", x: 46, y: 571, width: 167, height: 130, rotation: 0, imageRotation: 0 },
        { id: "5", x: 221, y: 154, width: 695, height: 546, rotation: 0, imageRotation: 0 },
        { id: "6", x: 924, y: 154, width: 166, height: 269, rotation: 0, imageRotation: 0 },
        { id: "7", x: 924, y: 431, width: 166, height: 269, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "po-07-h5v2-10",
    name: "PO 10 - H5V2",
    albumType: "PO",
    thumbnail: "/thumbnails/PO/po-07-h5_v2_10.png",
    size: [1136, 854],
    style: {},
    slots: [
        { id: "1", x: 46, y: 154, width: 697, height: 546, rotation: 0, imageRotation: 0 },      
        { id: "2", x: 751, y: 154, width: 166, height: 131, rotation: 0, imageRotation: 0 },
        { id: "3", x: 751, y: 293, width: 166, height: 130, rotation: 0, imageRotation: 0 },
        { id: "4", x: 751, y: 431, width: 166, height: 131, rotation: 0, imageRotation: 0 },
        { id: "5", x: 751, y: 570, width: 166, height: 130, rotation: 0, imageRotation: 0 },
        { id: "6", x: 925, y: 154, width: 165, height: 269, rotation: 0, imageRotation: 0 },
        { id: "7", x: 925, y: 431, width: 165, height: 269, rotation: 0, imageRotation: 0 }
    ],
}
];